import { ArrowRight, MousePointerClick } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { fmtCount } from "@/lib/format";

const FinalCTA = ({ clicks, onJoin }) => (
  <section data-testid="final-cta-section" className="py-20 sm:py-28 bg-white">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2.5rem] bg-gradient-to-br from-amber-400 via-amber-400 to-amber-500 px-5 py-12 sm:px-16 sm:py-20 text-center">
          <div
            aria-hidden
            className="pointer-events-none absolute inset-0 opacity-20 honey-grain"
          />
          <div className="relative">
            <h2 className="font-display text-3xl sm:text-5xl font-extrabold tracking-tight text-zinc-900 leading-tight max-w-3xl mx-auto">
              Your internet is already working. It's time you got paid for it.
            </h2>
            <p className="mt-5 text-base sm:text-lg text-zinc-800/80 max-w-xl mx-auto">
              Join through this page and start with $3 already in your balance. Free forever, two
              minutes to set up.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
              <button
                data-testid="final-cta-join-button"
                onClick={() => onJoin("final_cta")}
                className="group inline-flex items-center gap-2.5 rounded-full bg-zinc-900 px-10 py-4 font-display text-base font-bold text-white hover:bg-zinc-800 transition-colors shadow-xl"
              >
                Join Honeygain — Get $3 Free
                <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
              </button>
              <span
                data-testid="final-cta-click-counter"
                className="inline-flex items-center gap-2 rounded-full bg-white/70 backdrop-blur px-4 py-3 text-sm font-semibold text-zinc-800"
              >
                <MousePointerClick className="w-4 h-4 text-amber-700" />
                {fmtCount(clicks)} joined through this page
              </span>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default FinalCTA;
